/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-fragments */
import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { Box, BoxProps, SvgIcon, Typography, TypographyProps } from '@mui/material';
import WithDescriptionTooltip from '../../WithDescriptionTooltip/WithDescriptionTooltip';
import { Dot } from './ChartTooltip';

export type ChartTooltipItemProps = Omit<BoxProps, 'title'> & {
  icon?: React.ReactNode;
  dotColor?: React.ComponentProps<typeof Dot>['color'];
  title?: React.ReactNode;
  titleProps?: TypographyProps;
  value?: string | number;
  valueProps?: TypographyProps;
  description?: string;
};

export const ChartTooltipTitle = ({ children, ...props }: TypographyProps) => (
  <Typography
    variant="body1"
    component="span"
    fontSize="inherit"
    fontWeight="inherit"
    width="100%"
    overflow="hidden"
    textOverflow="ellipsis"
    noWrap
    color="inherit"
    {...props}>
    <AvTooltip>{children}</AvTooltip>
  </Typography>
);

export const ChartTooltipItem = ({
  dotColor,
  icon,
  value,
  title,
  titleProps,
  valueProps,
  description,
  fontWeight = 600,
  fontSize = 12,
  color = 'var(--color-content-immutable-white)',
  ...boxProps
}: ChartTooltipItemProps) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    minHeight={22}
    width="100%"
    overflow="hidden"
    fontSize={fontSize}
    fontWeight={fontWeight}
    color={color}
    {...boxProps}>
    {dotColor ? <Dot color={dotColor} border="0.5px solid var(--color-border-base-primary)" flexShrink={0} /> : null}

    {icon ? (
      <SvgIcon viewBox="0 0 22 22" sx={{ width: 22, height: 22 }}>
        {icon}
      </SvgIcon>
    ) : null}

    <WithDescriptionTooltip
      badgify
      badgeProps={{ persistent: true, sx: { pr: 2.75, overflow: 'hidden', flexShrink: 1 } }}
      title={description}>
      <React.Fragment>
        {typeof title === 'string' ? (
          <ChartTooltipTitle {...titleProps}>
            <AvTooltip>{title}</AvTooltip>
          </ChartTooltipTitle>
        ) : (
          title
        )}
      </React.Fragment>
    </WithDescriptionTooltip>

    {value ? (
      <Typography
        ml="auto"
        component="span"
        variant="inherit"
        fontWeight={600}
        sx={{ color: 'var(--color-content-immutable-white)' }}
        {...valueProps}>
        {value}
      </Typography>
    ) : null}
  </Box>
);
